import React, { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Legal Pages for System Of Success - Shiksha Mitra
// Required for Meta WhatsApp Business API & Razorpay Integration

export function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Privacy Policy / गोपनीयता नीति</h1>
      <p className="text-gray-500 mb-8">Last Updated: February 24, 2025 | अंतिम अपडेट: 24 फरवरी, 2025</p>
      
      <div className="space-y-8 text-gray-700">
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Introduction / परिचय</h2>
          <p className="mb-3">
            System Of Success (&quot;Company&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;) operates the Shiksha Mitra (शिक्षा मित्र) school management platform. 
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform.
          </p>
          <p>
            System Of Success (&quot;कंपनी&quot;, &quot;हम&quot;, &quot;हमारा&quot;) शिक्षा मित्र स्कूल प्रबंधन प्लेटफ़ॉर्म का संचालन करती है। 
            यह गोपनीयता नीति बताती है कि जब आप हमारे प्लेटफ़ॉर्म का उपयोग करते हैं तो हम आपकी जानकारी कैसे एकत्र, उपयोग और सुरक्षित करते हैं।
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Information We Collect / हम कौन सी जानकारी एकत्र करते हैं</h2>
          <h3 className="font-medium mb-2">Personal Information / व्यक्तिगत जानकारी:</h3>
          <ul className="list-disc pl-6 space-y-1 mb-4">
            <li>Name (English and Hindi) / नाम (अंग्रेजी और हिंदी में)</li>
            <li>Phone number / फ़ोन नंबर</li>
            <li>Email address / ईमेल पता</li>
            <li>Date of Birth / जन्म तिथि</li>
            <li>Aadhaar Number (encrypted) / आधार नंबर (एन्क्रिप्टेड)</li>
            <li>Samagra ID / समग्र आईडी</li>
            <li>Address details / पता विवरण</li>
            <li>Bank account details (for scholarships) / बैंक खाता विवरण (छात्रवृत्ति हेतु)</li>
            <li>Parent/Guardian information / अभिभावक जानकारी</li>
            <li>Caste and category information / जाति और वर्ग जानकारी</li>
          </ul>
          
          <h3 className="font-medium mb-2">Academic Information / शैक्षणिक जानकारी:</h3>
          <ul className="list-disc pl-6 space-y-1 mb-4">
            <li>Admission records / प्रवेश रिकॉर्ड</li>
            <li>Attendance records / उपस्थिति रिकॉर्ड</li>
            <li>Examination results / परीक्षा परिणाम</li>
            <li>Fee payment history / शुल्क भुगतान इतिहास</li>
          </ul>

          <h3 className="font-medium mb-2">Technical Information / तकनीकी जानकारी:</h3>
          <ul className="list-disc pl-6 space-y-1">
            <li>IP address / आईपी पता</li>
            <li>Browser type / ब्राउज़र प्रकार</li>
            <li>Device information / डिवाइस जानकारी</li>
            <li>Usage data / उपयोग डेटा</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">3. How We Use Your Information / हम आपकी जानकारी का उपयोग कैसे करते हैं</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>To provide and maintain our school management services / स्कूल प्रबंधन सेवाएं प्रदान करने के लिए</li>
            <li>To process fee payments through Razorpay / Razorpay के माध्यम से शुल्क भुगतान प्रोसेस करने के लिए</li>
            <li>To send notifications via WhatsApp, SMS, and Email / WhatsApp, SMS और ईमेल द्वारा सूचनाएं भेजने के लिए</li>
            <li>To comply with government education department requirements / शिक्षा विभाग की आवश्यकताओं का पालन करने के लिए</li>
            <li>To generate reports for schools and parents / स्कूलों और अभिभावकों के लिए रिपोर्ट बनाने के लिए</li>
            <li>To improve our services / हमारी सेवाओं में सुधार के लिए</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Data Sharing / डेटा साझाकरण</h2>
          <p className="mb-3">We may share your information with:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Schools:</strong> Your child&apos;s school administration for educational purposes / शैक्षणिक उद्देश्यों के लिए आपके बच्चे का स्कूल प्रशासन</li>
            <li><strong>Payment Processors:</strong> Razorpay for fee payments (subject to their privacy policy) / शुल्क भुगतान के लिए Razorpay</li>
            <li><strong>Communication Services:</strong> WhatsApp/Meta for notifications / सूचनाओं के लिए WhatsApp/Meta</li>
            <li><strong>Government Bodies:</strong> Education department as required by law / कानून द्वारा आवश्यक शिक्षा विभाग</li>
          </ul>
          <p className="mt-3">We do not sell your personal information to third parties. / हम आपकी व्यक्तिगत जानकारी तीसरे पक्ष को नहीं बेचते।</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Data Security / डेटा सुरक्षा</h2>
          <p className="mb-3">We implement appropriate security measures including:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>SSL/TLS encryption for data transmission / डेटा ट्रांसमिशन के लिए SSL/TLS एन्क्रिप्शन</li>
            <li>Encrypted storage of sensitive data (Aadhaar, bank details) / संवेदनशील डेटा का एन्क्रिप्टेड स्टोरेज</li>
            <li>Role-based access control / भूमिका-आधारित एक्सेस नियंत्रण</li>
            <li>Regular security audits / नियमित सुरक्षा ऑडिट</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">6. Data Retention / डेटा प्रतिधारण</h2>
          <p>
            We retain student data for the duration of their enrollment plus 7 years as required by educational regulations. 
            Payment records are retained as per RBI guidelines.
          </p>
          <p className="mt-2">
            हम विद्यार्थी डेटा उनके नामांकन की अवधि + 7 वर्ष तक रखते हैं जैसा कि शैक्षणिक नियमों द्वारा आवश्यक है।
            भुगतान रिकॉर्ड RBI दिशानिर्देशों के अनुसार रखे जाते हैं।
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">7. Your Rights / आपके अधिकार</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Right to access your data / अपना डेटा देखने का अधिकार</li>
            <li>Right to correction of inaccurate data / गलत डेटा को सुधारने का अधिकार</li>
            <li>Right to data portability / डेटा पोर्टेबिलिटी का अधिकार</li>
            <li>Right to withdraw consent / सहमति वापस लेने का अधिकार</li>
          </ul>
          <p className="mt-3">To exercise these rights, contact your school administration or email us at admin@shiksha-mitra.com</p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">8. Children&apos;s Privacy / बच्चों की गोपनीयता</h2>
          <p>
            Our platform handles data of minors (students) with parental/guardian consent obtained through school enrollment. 
            We take extra precautions to protect children&apos;s data.
          </p>
          <p className="mt-2">
            हमारा प्लेटफ़ॉर्म स्कूल नामांकन के माध्यम से प्राप्त अभिभावक सहमति के साथ नाबालिगों (विद्यार्थियों) का डेटा संभालता है।
            हम बच्चों के डेटा की सुरक्षा के लिए अतिरिक्त सावधानी बरतते हैं।
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">9. WhatsApp/Meta Communication / WhatsApp/Meta संचार</h2>
          <p>
            By using our platform, you consent to receive educational notifications, attendance alerts, fee reminders, 
            and important announcements via WhatsApp. You can opt-out by contacting your school.
          </p>
          <p className="mt-2">
            हमारे प्लेटफ़ॉर्म का उपयोग करके, आप WhatsApp के माध्यम से शैक्षणिक सूचनाएं, उपस्थिति अलर्ट, शुल्क रिमाइंडर 
            और महत्वपूर्ण घोषणाएं प्राप्त करने के लिए सहमति देते हैं।
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">10. Contact Us / संपर्क करें</h2>
          <div className="bg-gray-50 p-4 rounded-lg">
            <p className="font-semibold">System Of Success</p>
            <p>Email: admin@shiksha-mitra.com</p>
            <p>Phone: +91-9183100206</p>
            <p>Address: 112 Samvid Nagar, Kanadiya Road, Indore, Madhya Pradesh 452016</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">11. Changes to This Policy / इस नीति में परिवर्तन</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page 
            and updating the &quot;Last Updated&quot; date.
          </p>
        </section>
      </div>
    </div>
  );
}

export function TermsConditions() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Terms & Conditions / नियम और शर्तें</h1>
      <p className="text-gray-500 mb-8">Last Updated: February 24, 2025 | अंतिम अपडेट: 24 फरवरी, 2025</p>
      
      <div className="space-y-8 text-gray-700">
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Acceptance of Terms / शर्तों की स्वीकृति</h2>
          <p>
            By accessing and using Shiksha Mitra (शिक्षा मित्र), a product of System Of Success, you agree to be bound by these 
            Terms and Conditions. If you do not agree, please do not use our services.
          </p>
          <p className="mt-2">
            शिक्षा मित्र का उपयोग करके, जो System Of Success का उत्पाद है, आप इन नियमों और शर्तों से बंधे होने के लिए सहमत हैं।
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Services / सेवाएं</h2>
          <p className="mb-3">Shiksha Mitra provides the following services:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>School administration and management / स्कूल प्रशासन और प्रबंधन</li>
            <li>Student information management / विद्यार्थी जानकारी प्रबंधन</li>
            <li>Attendance tracking / उपस्थिति ट्रैकिंग</li>
            <li>Fee collection and management / शुल्क संग्रह और प्रबंधन</li>
            <li>Communication tools (WhatsApp, SMS, Email) / संचार उपकरण</li>
            <li>Examination and results management / परीक्षा और परिणाम प्रबंधन</li>
            <li>Report generation / रिपोर्ट निर्माण</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">3. User Accounts / उपयोगकर्ता खाते</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>You must provide accurate and complete information / आपको सही और पूर्ण जानकारी प्रदान करनी होगी</li>
            <li>You are responsible for maintaining account security / आप खाता सुरक्षा के लिए जिम्मेदार हैं</li>
            <li>You must not share your login credentials / आपको अपना लॉगिन क्रेडेंशियल साझा नहीं करना चाहिए</li>
            <li>Notify us immediately of any unauthorized access / किसी भी अनधिकृत पहुंच की तुरंत सूचना दें</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">4. User Responsibilities / उपयोगकर्ता की जिम्मेदारियां</h2>
          <p className="mb-2">Users agree to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Use the platform only for legitimate educational purposes / प्लेटफ़ॉर्म का उपयोग केवल वैध शैक्षणिक उद्देश्यों के लिए करें</li>
            <li>Not misuse or attempt to hack the system / सिस्टम का दुरुपयोग या हैक करने का प्रयास न करें</li>
            <li>Provide accurate student and parent information / सही विद्यार्थी और अभिभावक जानकारी प्रदान करें</li>
            <li>Respect data privacy of other users / अन्य उपयोगकर्ताओं की डेटा गोपनीयता का सम्मान करें</li>
            <li>Pay fees on time as per school policy / स्कूल नीति के अनुसार समय पर शुल्क का भुगतान करें</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Payment Terms / भुगतान शर्तें</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>All payments are processed securely through Razorpay / सभी भुगतान Razorpay के माध्यम से सुरक्षित रूप से प्रोसेस होते हैं</li>
            <li>Fee structure is determined by individual schools / शुल्क संरचना व्यक्तिगत स्कूलों द्वारा निर्धारित की जाती है</li>
            <li>Payment receipts are generated automatically / भुगतान रसीदें स्वचालित रूप से बनती हैं</li>
            <li>For refund queries, contact your school administration / वापसी प्रश्नों के लिए अपने स्कूल प्रशासन से संपर्क करें</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">6. Intellectual Property / बौद्धिक संपदा</h2>
          <p>
            All content, features, and functionality of Shiksha Mitra are owned by System Of Success and are protected 
            by copyright, trademark, and other intellectual property laws.
          </p>
          <p className="mt-2">
            शिक्षा मित्र की सभी सामग्री, सुविधाएं और कार्यक्षमता System Of Success के स्वामित्व में हैं।
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">7. Limitation of Liability / दायित्व की सीमा</h2>
          <p>
            System Of Success shall not be liable for any indirect, incidental, special, consequential, or punitive damages 
            arising from your use of the platform.
          </p>
          <p className="mt-2">
            System Of Success प्लेटफ़ॉर्म के आपके उपयोग से उत्पन्न किसी भी अप्रत्यक्ष, आकस्मिक, विशेष या परिणामी क्षति के लिए उत्तरदायी नहीं होगा।
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">8. Service Availability / सेवा उपलब्धता</h2>
          <p>
            We strive for 99.9% uptime but do not guarantee uninterrupted service. Scheduled maintenance will be notified in advance.
          </p>
          <p className="mt-2">
            हम 99.9% अपटाइम के लिए प्रयास करते हैं लेकिन निर्बाध सेवा की गारंटी नहीं देते। अनुसूचित रखरखाव की पूर्व सूचना दी जाएगी।
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">9. Termination / समाप्ति</h2>
          <p>
            We reserve the right to suspend or terminate accounts that violate these terms or engage in fraudulent activities.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">10. Governing Law / शासकीय कानून</h2>
          <p>
            These terms are governed by the laws of India. Any disputes shall be resolved in the courts of [Your City], Madhya Pradesh.
          </p>
          <p className="mt-2">
            ये शर्तें भारत के कानूनों द्वारा शासित हैं। कोई भी विवाद मध्य प्रदेश के न्यायालयों में हल किया जाएगा।
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">11. Contact / संपर्क</h2>
          <div className="bg-gray-50 p-4 rounded-lg">
            <p className="font-semibold">System Of Success</p>
            <p>Email: admin@shiksha-mitra.com</p>
            <p>Phone: +91-9183100206</p>
          </div>
        </section>
      </div>
    </div>
  );
}

export function RefundPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Refund & Cancellation Policy / वापसी और रद्दीकरण नीति</h1>
      <p className="text-gray-500 mb-8">Last Updated: February 24, 2025 | अंतिम अपडेट: 24 फरवरी, 2025</p>
      
      <div className="space-y-8 text-gray-700">
        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Overview / अवलोकन</h2>
          <p>
            This policy outlines the refund and cancellation procedures for fee payments made through Shiksha Mitra platform 
            powered by Razorpay payment gateway.
          </p>
          <p className="mt-2">
            यह नीति Razorpay भुगतान गेटवे द्वारा संचालित शिक्षा मित्र प्लेटफ़ॉर्म के माध्यम से किए गए शुल्क भुगतान के लिए 
            वापसी और रद्दीकरण प्रक्रियाओं को रेखांकित करती है।
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Fee Payment Refunds / शुल्क भुगतान वापसी</h2>
          
          <h3 className="font-medium mt-4 mb-2">Eligible for Refund / वापसी के योग्य:</h3>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>Duplicate payment due to technical error / तकनीकी त्रुटि के कारण डुप्लिकेट भुगतान</li>
            <li>Payment made to wrong school account / गलत स्कूल खाते में भुगतान</li>
            <li>Amount deducted but transaction failed / राशि कटी लेकिन लेनदेन विफल</li>
            <li>Excess payment beyond the due amount / देय राशि से अधिक भुगतान</li>
          </ul>

          <h3 className="font-medium mt-4 mb-2">Not Eligible for Refund / वापसी के योग्य नहीं:</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Fees paid as per school admission policy / स्कूल प्रवेश नीति के अनुसार भुगतान किया गया शुल्क</li>
            <li>Processing fees or convenience charges / प्रोसेसिंग शुल्क या सुविधा शुल्क</li>
            <li>Fees for services already rendered / पहले से प्रदान की गई सेवाओं के लिए शुल्क</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Refund Process / वापसी प्रक्रिया</h2>
          <ol className="list-decimal pl-6 space-y-3">
            <li>
              <strong>Step 1:</strong> Contact your school administration with payment details (Transaction ID, Date, Amount)
              <br/><span className="text-gray-500">स्कूल प्रशासन से भुगतान विवरण के साथ संपर्क करें</span>
            </li>
            <li>
              <strong>Step 2:</strong> School verifies the refund eligibility
              <br/><span className="text-gray-500">स्कूल वापसी पात्रता की पुष्टि करता है</span>
            </li>
            <li>
              <strong>Step 3:</strong> Approved refunds are processed within 7-10 business days
              <br/><span className="text-gray-500">स्वीकृत वापसी 7-10 कार्य दिवसों में प्रोसेस की जाती है</span>
            </li>
            <li>
              <strong>Step 4:</strong> Amount credited to original payment method
              <br/><span className="text-gray-500">राशि मूल भुगतान विधि में जमा की जाती है</span>
            </li>
          </ol>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Refund Timeline / वापसी समयसीमा</h2>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300">
              <thead>
                <tr className="bg-gray-50">
                  <th className="border border-gray-300 px-4 py-2 text-left">Payment Method / भुगतान विधि</th>
                  <th className="border border-gray-300 px-4 py-2 text-left">Refund Time / वापसी समय</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">UPI / यूपीआई</td>
                  <td className="border border-gray-300 px-4 py-2">3-5 business days / 3-5 कार्य दिवस</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">Debit Card / डेबिट कार्ड</td>
                  <td className="border border-gray-300 px-4 py-2">5-7 business days / 5-7 कार्य दिवस</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">Credit Card / क्रेडिट कार्ड</td>
                  <td className="border border-gray-300 px-4 py-2">7-10 business days / 7-10 कार्य दिवस</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">Net Banking / नेट बैंकिंग</td>
                  <td className="border border-gray-300 px-4 py-2">5-7 business days / 5-7 कार्य दिवस</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Admission Cancellation / प्रवेश रद्दीकरण</h2>
          <p className="mb-3">
            Admission cancellation and related fee refunds are governed by individual school policies. Generally:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Cancellation within 15 days of admission: Up to 90% refund (minus processing fees) / प्रवेश के 15 दिनों के भीतर: 90% तक वापसी</li>
            <li>Cancellation within 30 days: Up to 75% refund / 30 दिनों के भीतर: 75% तक वापसी</li>
            <li>Cancellation after 30 days: As per school policy / 30 दिनों के बाद: स्कूल नीति के अनुसार</li>
          </ul>
          <p className="mt-3 text-gray-600 italic">
            Note: Each school has its own refund policy. Please contact your school administration for specific details.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">6. Platform Subscription / प्लेटफ़ॉर्म सदस्यता</h2>
          <p>
            For schools using Shiksha Mitra subscription services:
          </p>
          <ul className="list-disc pl-6 space-y-2 mt-2">
            <li>Monthly subscriptions: No refund for partial months / मासिक: आंशिक महीने के लिए कोई वापसी नहीं</li>
            <li>Annual subscriptions: Pro-rata refund available within first 30 days / वार्षिक: पहले 30 दिनों में प्रो-राटा वापसी उपलब्ध</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">7. How to Request Refund / वापसी का अनुरोध कैसे करें</h2>
          <div className="bg-orange-50 p-4 rounded-lg">
            <p className="font-medium mb-2">Contact your school administration with: / अपने स्कूल प्रशासन से संपर्क करें:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Transaction ID / लेनदेन आईडी</li>
              <li>Payment Date / भुगतान तिथि</li>
              <li>Amount / राशि</li>
              <li>Reason for refund / वापसी का कारण</li>
              <li>Student admission number / विद्यार्थी प्रवेश क्रमांक</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 mb-3">8. Contact for Payment Issues / भुगतान समस्याओं के लिए संपर्क</h2>
          <div className="bg-gray-50 p-4 rounded-lg">
            <p className="font-semibold">System Of Success - Payment Support</p>
            <p>Email: admin@shiksha-mitra.com</p>
            <p>Phone: +91-9183100206</p>
            <p className="mt-2 text-sm text-gray-600">Support Hours: Mon-Sat, 9 AM - 6 PM IST</p>
          </div>
        </section>
      </div>
    </div>
  );
}

export function ContactUs() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Contact Us / संपर्क करें</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-4">System Of Success</h2>
            <p className="text-gray-600 mb-4">
              Developer of Shiksha Mitra (शिक्षा मित्र) - India&apos;s comprehensive school management platform.
            </p>
          </section>

          <section className="bg-orange-50 p-6 rounded-xl">
            <h3 className="font-semibold text-gray-800 mb-3">Head Office / मुख्य कार्यालय</h3>
            <div className="space-y-2 text-gray-600">
              <p className="flex items-start gap-2">
                <span>📍</span>
                <span>112 Samvid Nagar<br/>Kanadiya Road<br/>Indore, Madhya Pradesh 452016<br/>India</span>
              </p>
            </div>
          </section>

          <section className="bg-blue-50 p-6 rounded-xl">
            <h3 className="font-semibold text-gray-800 mb-3">Contact Details / संपर्क विवरण</h3>
            <div className="space-y-3 text-gray-600">
              <p className="flex items-center gap-2">
                <span>📞</span>
                <span>+91-9183100206</span>
              </p>
              <p className="flex items-center gap-2">
                <span>📧</span>
                <span>admin@shiksha-mitra.com</span>
              </p>
              <p className="flex items-center gap-2">
                <span>🌐</span>
                <span>www.shiksha-mitra.com</span>
              </p>
            </div>
          </section>

          <section className="bg-green-50 p-6 rounded-xl">
            <h3 className="font-semibold text-gray-800 mb-3">Support Hours / सहायता समय</h3>
            <div className="space-y-2 text-gray-600">
              <p>Monday - Saturday: 9:00 AM - 6:00 PM IST</p>
              <p>Sunday: Closed</p>
              <p className="text-sm mt-2">सोमवार - शनिवार: सुबह 9 बजे - शाम 6 बजे</p>
            </div>
          </section>
        </div>

        <div className="space-y-6">
          <section className="bg-white border rounded-xl p-6">
            <h3 className="font-semibold text-gray-800 mb-4">Department Contacts / विभागीय संपर्क</h3>
            
            <div className="space-y-4">
              <div className="border-b pb-3">
                <p className="font-medium text-gray-800">General Inquiries / सामान्य पूछताछ</p>
                <p className="text-gray-600 text-sm">admin@shiksha-mitra.com</p>
              </div>
              
              <div className="border-b pb-3">
                <p className="font-medium text-gray-800">Technical Support / तकनीकी सहायता</p>
                <p className="text-gray-600 text-sm">admin@shiksha-mitra.com</p>
              </div>
              
              <div className="border-b pb-3">
                <p className="font-medium text-gray-800">Payment Issues / भुगतान समस्याएं</p>
                <p className="text-gray-600 text-sm">admin@shiksha-mitra.com</p>
              </div>
              
              <div className="border-b pb-3">
                <p className="font-medium text-gray-800">School Onboarding / स्कूल पंजीकरण</p>
                <p className="text-gray-600 text-sm">admin@shiksha-mitra.com</p>
              </div>
              
              <div className="border-b pb-3">
                <p className="font-medium text-gray-800">Privacy Concerns / गोपनीयता संबंधित</p>
                <p className="text-gray-600 text-sm">admin@shiksha-mitra.com</p>
              </div>
              
              <div>
                <p className="font-medium text-gray-800">Legal / कानूनी</p>
                <p className="text-gray-600 text-sm">admin@shiksha-mitra.com</p>
              </div>
            </div>
          </section>

          <section className="bg-purple-50 p-6 rounded-xl">
            <h3 className="font-semibold text-gray-800 mb-3">WhatsApp Support</h3>
            <p className="text-gray-600 mb-3">
              Quick support via WhatsApp for schools and parents.
            </p>
            <p className="text-lg font-medium text-purple-700">+91-9183100206</p>
          </section>

          <section className="bg-yellow-50 p-6 rounded-xl">
            <h3 className="font-semibold text-gray-800 mb-3">Grievance Officer / शिकायत अधिकारी</h3>
            <p className="text-gray-600">
              For unresolved complaints, contact our Grievance Officer:
            </p>
            <div className="mt-2 text-gray-700">
              <p className="font-medium">[Officer Name]</p>
              <p>admin@shiksha-mitra.com</p>
              <p>+91-9183100206</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export function AboutUs() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${API_URL}/api/brand-pages/public`);
        const data = await res.json();
        if (data?.success) setContent(data.content || null);
      } catch (err) {
        console.error(err);
      }
    };
    load();
  }, []);

  const teamMembers = content?.team_members || [
    { role: 'Founder / Leadership', summary: 'Strategy, vision, long-term direction, and category leadership', image_url: '' },
    { role: 'Product & Engineering', summary: 'ERP modules, AI systems, automations, integrations, and platform infrastructure', image_url: '' },
    { role: 'Growth & Outreach', summary: 'School acquisition, CRM, campaigns, and conversion systems', image_url: '' },
    { role: 'School Success', summary: 'Onboarding, adoption, training, activation, and go-live support', image_url: '' },
  ];

  return (
    <div className="min-h-screen bg-slate-50">
      <section className="relative bg-gradient-to-br from-slate-950 via-slate-900 to-orange-600 text-white px-4 py-20 overflow-hidden">
        {content?.about_hero_image && <img src={content.about_hero_image} alt="About hero" className="absolute inset-0 h-full w-full object-cover opacity-20" />}
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.35em] text-white/60">About Us</p>
          <h1 className="mt-4 text-4xl md:text-6xl font-black">{content?.about_hero_title || 'System Of Success × शिक्षा मित्र'}</h1>
          <p className="mt-5 max-w-3xl mx-auto text-lg text-white/80 leading-relaxed">
            {content?.about_hero_text || 'शिक्षा मित्र ek AI-first school operating platform hai jo schools ko sirf manage nahi, बल्कि grow karne ke liye बनाया गया है — admissions, ERP, communication, payments aur onboarding को एक business-critical flow में लाने के लिए.'}
          </p>
        </div>
      </section>

      <div className="max-w-6xl mx-auto px-4 py-12 space-y-10 text-slate-700">
        <section className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="rounded-3xl bg-white p-8 shadow-sm border border-slate-200">
            <h2 className="text-3xl font-black text-slate-900">{content?.vision_title || 'Our Vision / हमारा विज़न'}</h2>
            <p className="mt-4 leading-relaxed">{content?.vision_body || 'हर Indian school ko एक ऐसा unified AI operating system देना jahan principal ko control मिले, staff ko speed मिले aur parents ko trust मिले.'}</p>
          </div>
          <div className="rounded-3xl bg-white p-8 shadow-sm border border-slate-200">
            <h2 className="text-3xl font-black text-slate-900">{content?.mission_title || 'Our Mission / हमारा मिशन'}</h2>
            <p className="mt-4 leading-relaxed">{content?.mission_body || 'School administration ko simplify करना, admission aur communication systems ko stronger बनाना, aur education leaders ko ऐसे tools देना jo unka समय बचाएँ aur growth decisions ko faster बनाएँ.'}</p>
          </div>
        </section>

        <section className="rounded-3xl bg-white p-8 shadow-sm border border-slate-200">
          <h2 className="text-3xl font-black text-slate-900">Founder Story / संस्थापक की कहानी</h2>
          {(content?.founder_name || content?.founder_title) && (
            <div className="mt-5 flex items-center gap-4" data-testid="about-founder-card">
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-orange-500 to-amber-500 text-white flex items-center justify-center text-xl font-black shrink-0">
                {(content?.founder_name || 'S').trim().charAt(0).toUpperCase()}
              </div>
              <div>
                {content?.founder_name && <p className="text-lg font-bold text-slate-900" data-testid="about-founder-name">{content.founder_name}</p>}
                {content?.founder_title && <p className="text-sm font-semibold text-orange-600">{content.founder_title}</p>}
              </div>
            </div>
          )}
          <p className="mt-4 leading-relaxed">{content?.founder_story || 'यह section founder story ke लिए reserved hai. Platform Admin isse later real brand story, why-now context, aur institutional journey ke साथ update कर सकता है.'}</p>
        </section>

        <section className="rounded-3xl bg-white p-8 shadow-sm border border-slate-200">
          <h2 className="text-3xl font-black text-slate-900">What We Believe / हम क्या मानते हैं</h2>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4 mt-6">
            {(content?.values_cards?.length ? content.values_cards : [
              { icon: '🤖', title: 'AI reduces admin load', text: 'AI should reduce admin load, not add complexity.' },
              { icon: '🌐', title: 'Bilingual by design', text: 'Bilingual experiences matter for Indian schools.' },
              { icon: '⚙️', title: 'One system', text: 'Operations + growth should live in one system.' },
              { icon: '🤝', title: 'Trust', text: 'Trust is built through clarity, speed, and support.' },
            ]).map((item, idx) => (
              <div key={idx} className="rounded-2xl bg-slate-50 p-5 border border-slate-100" data-testid={`about-value-card-${idx}`}>
                <div className="text-2xl mb-3">{item.icon || '✨'}</div>
                {item.title && <h3 className="font-bold text-slate-900 mb-1">{item.title}</h3>}
                <p className="leading-relaxed text-sm text-slate-600">{item.text}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="rounded-3xl bg-white p-8 shadow-sm border border-slate-200">
          <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <h2 className="text-3xl font-black text-slate-900">Team / टीम</h2>
              <p className="mt-2 text-slate-500">शिक्षा मित्र को बनाने और चलाने वाली टीम।</p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4 mt-8">
            {teamMembers.map((member, idx) => (
              <div key={idx} className="rounded-2xl border border-slate-200 bg-slate-50 p-5" data-testid={`about-team-member-${idx}`}>
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-slate-800 to-slate-600 text-white flex items-center justify-center text-lg font-bold mb-4">
                  {((member.name || member.role || '?').trim().charAt(0) || '?').toUpperCase()}
                </div>
                {member.name && <h3 className="font-bold text-slate-900 text-lg">{member.name}</h3>}
                {member.role && <p className="mt-0.5 text-sm font-semibold text-orange-600">{member.role}</p>}
                {member.summary && <p className="mt-2 text-sm text-slate-500 leading-relaxed">{member.summary}</p>}
              </div>
            ))}
          </div>
        </section>

        <section className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="rounded-3xl bg-white p-8 shadow-sm border border-slate-200 lg:col-span-2">
            <h2 className="text-3xl font-black text-slate-900">Milestones / यात्रा के पड़ाव</h2>
            <div className="mt-6 space-y-4">
              {(content?.milestones || []).map((item, idx) => (
                <div key={idx} className="rounded-2xl bg-slate-50 border border-slate-100 p-5">
                  {item.image_url && <img src={item.image_url} alt={item.title} className="mb-3 h-16 w-full rounded-xl object-cover" />}
                  <p className="text-sm font-bold text-orange-600">{item.year}</p>
                  <h3 className="mt-1 text-xl font-bold text-slate-900">{item.title}</h3>
                  <p className="mt-2 text-slate-500">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="space-y-6">
            <div className="rounded-3xl bg-white p-8 shadow-sm border border-slate-200">
              <h2 className="text-2xl font-black text-slate-900">Awards / Recognition</h2>
              <div className="mt-4 space-y-3">
                {(content?.awards || []).map((item, idx) => (
                  <div key={idx} className="rounded-2xl bg-slate-50 p-4 border border-slate-100">
                    {item.image_url && <img src={item.image_url} alt={item.title} className="mb-3 h-14 w-full rounded-xl object-cover bg-white" />}
                    <p className="text-sm font-bold text-orange-600">{item.year}</p>
                    <p className="mt-1 text-slate-700">{item.title}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="rounded-3xl bg-white p-8 shadow-sm border border-slate-200">
              <h2 className="text-2xl font-black text-slate-900">Media Mentions</h2>
              <div className="mt-4 space-y-3">
                {(content?.media_mentions || []).map((item, idx) => (
                  <div key={idx} className="rounded-2xl bg-slate-50 p-4 border border-slate-100">
                    {item.image_url && <img src={item.image_url} alt={item.outlet} className="mb-3 h-14 w-full rounded-xl object-cover bg-white" />}
                    <p className="text-sm font-bold text-orange-600">{item.outlet}</p>
                    <p className="mt-1 text-slate-700">{item.title}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="rounded-3xl bg-slate-950 text-white p-8 shadow-xl">
          <h2 className="text-3xl font-black">Contact Us / संपर्क करें</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6 text-white/80">
            <div>
              <p className="font-semibold text-white">System Of Success</p>
              <p>112 Samvid Nagar, Kanadiya Road, Indore, MP 452016</p>
              <p>India</p>
            </div>
            <div>
              <p>Email: admin@shiksha-mitra.com</p>
              <p>Phone: +91-9183100206</p>
              <p>Website: www.shiksha-mitra.com</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

// Export all legal pages
export default {
  PrivacyPolicy,
  TermsConditions,
  RefundPolicy,
  ContactUs,
  AboutUs
};
